<template>
    <sidebar-left>
        <slot slot="sidebar-left">
            <SideMenu :SideMenuLinks="sideMenuLinks"></SideMenu>
        </slot>
        <slot slot="main">
            <div class="u-max-700 u-center-block history__detail-wrapper">
                <page-header>
                    <slot slot="title">{{ $t('customer.account.history.detail.title') }}</slot>
                    <slot v-if="!isMarketing && canReOrder" slot="description">
                        <!-- <p>{{ $t('customer.account.history.detail.description') }}</p> -->
                        <button @click.prevent="reOrder(null)" class="c-button c-button--alpha">{{ $t('customer.account.history.detail.re_order') }}</button>
                    </slot>
                </page-header>

                <section class="c-form-row o-page-bottom-spacing--medium u-center-block">
                    <v-loading :data="HistoryOrderDetail" type="global"></v-loading>
                    <table class="c-overview-table">
                        <tr v-if="HistoryOrderDetail.OrderNumber">
                            <th>
                                {{ $t('customer.account.history.detail.order_number') }}
                            </th>
                            <td>
                                {{ HistoryOrderDetail.OrderNumber }}
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr v-if="HistoryOrderDetail.CustomerOrderDescription">
                            <th>
                                {{ $t('customer.account.history.detail.reference') }}
                            </th>
                            <td>
                                {{ HistoryOrderDetail.CustomerOrderDescription }}
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr v-if="HistoryOrderDetail.OrderDate">
                            <th>
                                {{ $t('customer.account.history.detail.order_date') }}
                            </th>
                            <td>
                                {{ HistoryOrderDetail.OrderDate | moment('DD-MM-YYYY') }}
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr v-if="HistoryOrderDetail.Status">
                            <th>
                                {{ $t('customer.account.history.detail.status') }}
                            </th>
                            <td>
                                {{ HistoryOrderDetail.Status }}
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr v-if="HistoryOrderDetail.InvoiceAddress || HistoryOrderDetail.DeliveryAddress" class="c-overview-table__row">
                            <th v-if="HistoryOrderDetail.InvoiceAddress">
                                {{ $t('customer.account.history.detail.invoice_address') }}
                            </th>
                            <td v-if="HistoryOrderDetail.InvoiceAddress" v-html="HistoryOrderDetail.InvoiceAddress">
                            </td>

                            <th v-if="HistoryOrderDetail.DeliveryAddress">
                                {{ $t('customer.account.history.detail.delivery_address') }}
                            </th>
                            <td style="width:1px; white-space: nowrap;" v-if="HistoryOrderDetail.DeliveryAddress" v-html="HistoryOrderDetail.DeliveryAddress">
                            </td>
                            <td>
                                <svgicon v-if="HistoryOrderDetail.IsDropshipment" width="1.4em" height="1.4em" name="dropshipment"></svgicon>
                            </td>
                        </tr>
                    </table>
                </section>

                <section v-if="HistoryOrderDetail.Shipments && HistoryOrderDetail.Shipments.length > 0" class="c-form-row o-page-bottom-spacing--large u-center-block">
                    <table class="c-overview-table">
                        <thead>
                            <tr>
                                <th>
                                    {{ $t('customer.account.history.detail.expected_delivery_date') }}
                                </th>
                                <th>
                                    {{ $t('customer.account.history.detail.delivery_state') }}
                                </th>
                                <th>
                                    {{ $t('customer.account.history.detail.tracking_code') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="shipment in HistoryOrderDetail.Shipments" :key="shipment.Id">
                                <td>
                                    <template v-if="shipment.Status=='Delivered'">{{ shipment.DeliveryDate | moment('DD-MM-YYYY  HH:mm') }}</template>
                                    <template v-else-if="shipment.DeliveryDate">{{ shipment.DeliveryDate | moment('DD-MM-YYYY') }}</template>
                                    <template v-else>{{ $t('customer.account.history.detail.no_date_announced') }}</template>
                                </td>
                                <td>
                                    {{ shipment.Status }}
                                </td>
                                <td>
                                    <a :href="shipment.TrackingUrl" target="_blank">
                                        <template v-if="shipment.TrackingCode">{{ shipment.TrackingCode }}</template>
                                        <template v-else>{{ shipment.TrackingUrl }}</template>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <section v-else>
                    <p>
                        {{ $t('customer.account.history.detail.no_shipments') }}
                    </p>
                </section>

                <section class="c-form-row o-page-bottom-spacing--medium u-center-block">
                    <div class="c-product-overview-header">
                        <div class="c-product-overview-header__item">
                            <span class="u-bold">
                                {{ $t('customer.account.history.detail.product_count') }}:
                            </span>
                            <span v-if="HistoryOrderDetail && HistoryOrderDetail.Products">
                                {{ HistoryOrderDetail.Products.length }}
                            </span>
                        </div>
                        <div v-if="!isMarketing" class="c-product-overview-header__item">
                            <span class="u-bold">
                                {{ $t('customer.account.history.detail.total_price') }}:
                            </span>
                            {{ HistoryOrderDetail.Total | currency(customerCurrencySymbol) }}
                        </div>
                    </div>
                    <ProductsTable :products="HistoryOrderDetail.Products" :showReOrder=true @shoppingCartButtonClicked="reOrder"></ProductsTable>

                    <div class="u-flex u-flex--content-between">
                        <button @click="downloadImages" class="c-button c-button--alpha">{{ $t('customer.account.history.detail.download_images') }}</button>
                        <button v-if="isAllowed && HistoryOrderDetail.Invoices && !HistoryOrderDetail.Invoices.length" @click="requestInvoice" class="c-button c-button--alpha">{{ $t('customer.account.history.detail.request_invoice') }}</button>
                        <button v-if="isAllowed && HistoryOrderDetail.Invoices && HistoryOrderDetail.Invoices.length" @click="downloadItem" class="c-button c-button--alpha c-button--icon">
                            <svgicon name="file-pdf" width="25" height="25"></svgicon>
                            <span>{{ $t('customer.account.history.detail.download_invoice') }}</span>
                        </button>
                        <button @click="downloadCsv" class="c-button c-button--neutral">{{ $t('global.download_csv') }}</button>
                  </div>
                </section>
            </div>
        </slot>
    </sidebar-left>
</template>

<script>

    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'
    import ProductsTable from '@/components/shop/ProductsTable'
    import VLoading from '@/components/Loading'
    import FilesHelper from '@/helpers/files'

    import {mapGetters} from 'vuex'
    import axios from "axios";
    import {config} from "../../../api/__http";

    export default {
        components: {
            PageHeader,
            SideMenu,
            SidebarLeft,
            ProductsTable,
            VLoading
        },
        data() {
            return {
            }
        },
        created(){
            this.$store.dispatch('getHistoryOrderDetail', {id : this.$attrs.id})
        },
        computed: {
            ...mapGetters({
                HistoryOrderDetail: 'historyOrderDetail'
            }),
            isAllowed() {
                return this.$store.getters.userInfo.impersonated || this.$store.getters.userInfo.role == "Klant";
            },
            sideMenuLinks() {
                let menu = [
                    {
                        title: 'customer.account.edit.title',
                        route: '/customer/account/edit',
                    }
                ];

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.users.title',
                        route: '/customer/account/users'
                    });
                    menu.push({
                        title: 'customer.account.addresses.title',
                        route: '/customer/account/addresses'
                    });
                }

                if(this.isCustomer || this.isMarketing) {
                    menu.push({
                        title: 'customer.account.history.title',
                        route: '/customer/account/history'
                    });

                    menu.push({
                        title: 'customer.account.backorders.title',
                        route: '/customer/account/backorders'
                    })
                }

                if(this.isCustomer) {
                    menu.push({
                        title: 'customer.account.invoices.title',
                        route: '/customer/account/invoices'
                    });
                }

              return menu;
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            },
            canReOrder(){
                return this.HistoryOrderDetail && this.HistoryOrderDetail.Products && this.HistoryOrderDetail.Products.every(product => {
                    return product && product.Status !== 'PRE' && product.Status !== 'PRE2' && product.IsWebshopEnabled && !product.IsDisabled;
                })
            },
            customerCurrencySymbol() {
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: {
            downloadImages() {
                this.$store.dispatch('downloadImages', this.$attrs.id).then((response) => {
                    window.location = response.Url;
                });
            },
            downloadCsv(){
                this.$store.dispatch('downloadOrderLinesCsv', this.$attrs.id).then((response) => {
                    response = "\uFEFF" + response;
                    FilesHelper.saveFile("Order-Lines.csv", "text/csv;charset=utf-8", response);
                });
            },
            reOrder(productVariantId){
                let body = [];

                if(productVariantId) body.push(productVariantId);
                this.$store.dispatch('reOrder', {
                    id: this.$attrs.id,
                    body: body
                }).then((result) => {
                    if(result.Errors && result.Errors.length > 0) {
                        result.Errors.forEach(e => {
                            this.$notify({
                                group: 'global',
                                title: e,
                                type: 'error',
                                duration: 4000
                            });
                        });
                    } else {
                        this.$notify({
                            group: 'global',
                            title: this.$t('customer.shop.detail.productsAdded'),
                            type: 'success',
                            duration: 4000
                        });
                        this.$store.dispatch('getBasket');
                    }
                });
            },
            shoppingCartButtonClicked(productId){

            },
            requestInvoice() {
                this.$store.dispatch('requestInvoice', this.HistoryOrderDetail.OrderNumber).then(() => {
                    this.$notify({
                        group: 'global',
                        title: this.$t('customer.account.history.detail.invoice_requested'),
                        type: 'success',
                        duration: 4000
                    });
                });
            },
            downloadItem () {
                this.HistoryOrderDetail.Invoices.forEach((invoice) => {
                    document.body.style.cursor = 'progress';
                    axios({
                        url: config.baseUrl() + '/Customer/Invoice/' + invoice.InvoiceNumber,
                        method: 'GET',
                        responseType: 'blob',

                    }).then((response) => {
                        const url = window.URL.createObjectURL( new Blob([response.data],{ type: "application/pdf" }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', invoice.InvoiceNumber + '.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        document.body.style.cursor = 'auto';
                    });
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-overview-table {
        width: 100%;
        th {
            width: 1px;
            white-space: nowrap;
        }

        td,
        th {
            text-align: left;
            vertical-align: top;
            padding: .25em 0;

            &:not(:last-child) {
                padding-right: .5em;
            }
        }

        &__row {
            td,
            th {
                padding-top: 2em;
                padding-bottom: 2em;
            }
        }
    }

    .c-product-overview-header {
        display: flex;
        flex-wrap: wrap;
        background-color: whitesmoke;
        padding: 15px;
        @include rfs(15);
        margin-bottom: 20px;

        &__item {
            &:not(:last-child) {
                padding-right: 3em;
            }
        }
    }

    .history__detail-wrapper {
        margin-right: 0 !important;
        max-width: 43.88889em;
    }
</style>



// WEBPACK FOOTER //
// src/views/customer/account/HistoryDetail.vue